import { Component, OnInit } from '@angular/core';
import { TabsModule } from 'primeng/tabs';
import { CommonModule } from '@angular/common';
import { AccountComponent } from "./account/account.component";
import { UsersComponent } from './user/user-list/user-list.component';
import { ListOrganizationComponent } from "./organization/list-organization/list-organization.component";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-settings',
  imports: [CommonModule, TabsModule, AccountComponent, UsersComponent, ListOrganizationComponent],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {
  tabvalue = "account";

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.fragment.subscribe((fragment) => {

      if(fragment) {
        this.tabvalue = fragment
      }
    });
  } 
}
